import { Navigate, Outlet } from "react-router-dom";

import authHelper from "../helpers/auth";

const AuthRoutes = () => {
    const tokenValidationRes = authHelper.isAuthTokenValid();

    return (
        !tokenValidationRes.result
            ? <Outlet />
            : <Navigate to="/" replace />
    );
};

export default AuthRoutes;